import { render } from "./LiftEntrance.vue?vue&type=template&id=257ae679&scoped=true&bindings={\"doorOpened\":\"data\",\"doorSound\":\"data\",\"openDoor\":\"options\",\"goToNextStep\":\"options\"}"
import script from "./LiftEntrance.vue?vue&type=script&lang=js"
export * from "./LiftEntrance.vue?vue&type=script&lang=js"

import "./LiftEntrance.vue?vue&type=style&index=0&id=257ae679&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-257ae679"

export default script